module.exports = __webpack_public_path__ + "static/media/highlight.4916b6ba.png";